var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.14244,
    y: 2.42857,
    width: 7.71429,
    height: 11.1429,
    rx: 1.28571,
    stroke: "#002A69",
    strokeWidth: 0.857143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 4.5H2.85714C2.38376 4.5 2 4.88376 2 5.35714V10.8571C2 11.2122 2.28782 11.5 2.64286 11.5H2.84821C3.08984 11.5 3.28571 11.3041 3.28571 11.0625V10.8393C3.28571 10.7209 3.18978 10.625 3.07143 10.625C2.95308 10.625 2.85714 10.5291 2.85714 10.4107V9.30367C2.85714 9.06698 3.04902 8.8751 3.28572 8.8751H12.7143C12.951 8.8751 13.1429 9.06698 13.1429 9.30367V10.4107C13.1429 10.5291 13.0469 10.625 12.9286 10.625C12.8102 10.625 12.7143 10.7209 12.7143 10.8393V11.0625C12.7143 11.3041 12.9102 11.5 13.1518 11.5H13.3571C13.7122 11.5 14 11.2122 14 10.8571V5.35714C14 4.88376 13.6162 4.5 13.1429 4.5Z",
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42871,
    y: 9.71436,
    width: 5.14286,
    height: 0.857143,
    rx: 0.428571,
    fill: "#002A69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42871,
    y: 11,
    width: 2.57143,
    height: 0.857143,
    rx: 0.428571,
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/Fax.40129c99c9bc35ec38bc5390e63bba52.svg";
export { ForwardRef as ReactComponent };